<template>
    <div id="overlay">
        <div class="dialog-wrap">
            <div class='select-friend-top'>
                <div>
                    <span class="select-friend-close-btn" @click="CloseEvent">×</span>
                </div>
                <div>
                    <div class='dialog_title'>お友達選択</div>
                    <div class="p-4">
                        <div class="scrollY">
                            <div v-for="item in friendPlayerSelectList" :key="item.id">
                                <input
                                    :id="item.id"
                                    type="checkbox"
                                    class="select-friend-checkbox"
                                    v-model="selectedFriendPlayers"
                                    :value="item">
                                <div class="w-100 mb-1 friend-select-name-content">
                                    <label :for="item.id" class="p-1 friend-select-name">
                                        {{ item.family_name }}&nbsp;{{ item.given_name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <p v-if="alertError == false" class="text-danger">{{count}}名まで選択可能となっています</p>
                        <div>
                            <button class='bluebackbutton dialogBtn' v-on:click="ClickEvent">登&nbsp;&nbsp;録</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_FRIEND_LIST } from '../../../constants/golf_friend';

export default {
    components: {
    },
    data () {
        return {
            // 選択されたmember_no
            selectedFriendPlayers: [],
            // 友達リスト
            friendPlayerSelectList: [],
            FriendPlayer: [],
            count: null,
            alertError: true,
            select: [],
            loadingCount: 0
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.friendPlayerSelectList = [];
            this.GetFriendList();
        },
        /** ----------------------------------------------
         * 友達一覧取得
         * @param count 選択可能数
         * ---------------------------------------------- */
        GetFriendList: function (count,loginUserMemberNo) {
            this.$store.commit("loading/setIsLoading", true);
            
            this.friendPlayerSelectList = [];

            this.$apollo.mutate({
                mutation: GET_FRIEND_LIST,
                variables: {
                    member_no: String(loginUserMemberNo),
                    limit: 999,
                    offset: 0
                }
            })
            .then(res => {
                this.friendPlayerSelectList = res.data.getGolfFriendList.GolfFriendList;
                this.count = count;
                this.$store.commit("loading/setIsLoading", false);
            })
            .catch(error => {
                this.error = error;
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        /** ----------------------------------------------
         * 登録ボタン押下
         * ---------------------------------------------- */
        ClickEvent (){
            this.friendPlayerSelectList = [];
            // 入力欄が空欄の人数より選択された人数の方が多い場合
            if (this.count < this.selectedFriendPlayers.length) {
                this.alertError = false;
            }
            // 選択された人数が適正の場合
            else if ( this.count >= this.selectedFriendPlayers.length && this.selectedFriendPlayers.length >= 1) {
                this.alertError = true;
                for (var i = 0; i < this.selectedFriendPlayers.length; i++) {
                    this.selectedFriendPlayers[i].selectFlag = true;
                }
                this.$emit('fromSelectFriend-Dialog', this.selectedFriendPlayers);
                this.selectedFriendPlayers = [];
            // 誰も選択されなかったら
            } else if ( this.selectedFriendPlayers.length < 1) {
                this.alertError = true;
                this.selectedFriendPlayers = null;
                this.$emit('fromSelectFriend-Dialog', this.selectedFriendPlayers);
                this.selectedFriendPlayers = [];
            }
        },
         /** ----------------------------------------------
         * お友達押下
         * ---------------------------------------------- */
         /** ----------------------------------------------
         * ✖ボタン押下
         * ---------------------------------------------- */
        CloseEvent () {
            this.friendPlayerSelectList = [];
            this.alertError = true;
            this.selectedFriendPlayers = [];
            this.$emit('close-dialog');
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function (){
            this.loadingCount++;
            this.$store.commit("loading/setIsLoading", true);
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function (){
            this.loadingCount--;
            if (this.loadingCount == 0) {
                // this.$store.commit("loading/setIsLoading", false);
            }
        }
    }
}

</script>

<style scoped>
</style>
